import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/thesis-topics', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const store = data => {
  return httpClient
    .post('/api/thesis-topics', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getLevel = (Options = {}) => {
  return httpClient
    .get('/api/thesis-topics/levels', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const update = data => {
  return httpClient
    .put(`/api/thesis-topics/${data.topic_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/thesis-topics/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const destroy = id => {
  return httpClient
    .delete(`/api/thesis-topics/${id}`)
    .then(response => Promise.resolve(response.data))
}
export default {
  store,
  getLevel,
  get,
  find,
  update,
  destroy
}
